module.exports = __webpack_public_path__ + "static/media/user-cowboy.390c69d4.svg";